/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import { createContext } from 'react';

const animationContext = createContext({
  animation: 'next',
  setAnimation: (animation: 'next' | 'previous') => {},
  currentPageIndex: -1,
  setCurrentPageIndex: (index: number | ((value: number) => number)) => {},
});

export default animationContext;
